export const BRAND = {
  name: "Rockstar ATV Rentals",
  phone: "(407) 915-3661",
  phoneRaw: "4079153661",
  email: "Rockstaratvrentals@gmail.com",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_9b44fbad-fe9b-4c6f-95af-f6f83bba8972/artifacts/0qopb6rb_image.png",
  bookingUrl:
    "https://fareharbor.com/embeds/book/rockstaratvrentals/?full-items=yes&from-ssl=yes&g4=no&cp=no&csp=no&back=https%3A%2F%2Frockstaratvrentals.com%2F&u=25a42aa7-74f7-47d9-821a-3dc4556ca31e&language=en-us",
  waiverGoogleForm: "https://docs.google.com/forms/d/e/PLACEHOLDER_FORM_ID/viewform",
  waiverSheetWebhook: "https://script.google.com/macros/s/AKfycbwWWnCx9JftbMUekymkWV77DNWNJVlh-LxOTqUsjUsxdhu7IRf-1_GtA70PnHYC4i6UQQ/exec",
  waiverToken: "RAR-WAIVER-8f3k2p",
  locations: ["Kissimmee", "Ocala", "Orlando"],
};

export const FLEET = [
  {
    id: "talon-4",
    name: "Honda Talon 1000R4",
    variant: "4-Seater Side-by-Side",
    hp: "104 HP",
    seats: 4,
    minAge: 18,
    hourly: 300,
    twoHour: 425,
    deposit: 250,
    image: "/talon-1000r4.jpg",
    tag: "FAMILY-FLAGSHIP",
    accent: "red",
  },
  {
    id: "talon-2",
    name: "Honda Talon 1000X",
    variant: "2-Seater Side-by-Side",
    hp: "104 HP",
    seats: 2,
    minAge: 18,
    hourly: 225,
    twoHour: 295,
    deposit: 250,
    image: "/talon-1000x.jpg",
    tag: "DRIVERS-CHOICE",
    accent: "blue",
  },
  {
    id: "rancher-420",
    name: "Honda Rancher 420",
    variant: "Solo ATV / Four-Wheeler",
    hp: "27 HP",
    seats: 1,
    minAge: 10,
    hourly: 125,
    twoHour: 175,
    passenger: 15,
    deposit: 100,
    image: "/rancher-420.jpg",
    tag: "AGGRO-RANGER",
    accent: "red",
  },
];

export const REVIEWS = [
  { name: "Marcus H.", city: "Orlando, FL", rating: 5, text: "Best day we've had in Florida. Talon 1000 tore through every trail. Book the 2-hour, worth every dollar." },
  { name: "Kaitlyn R.", city: "Kissimmee, FL", rating: 5, text: "Guide made my kids feel safe and stoked. The beach stop with the ATVs? Insane." },
  { name: "Diego P.", city: "Ocala, FL", rating: 5, text: "Rented three Ranchers for our bachelor party. These guys run a tight ship. Highly recommend." },
  { name: "Priya S.", city: "Tampa, FL", rating: 5, text: "Machines were spotless, gear was clean, the ride was pure adrenaline. Coming back next month." },
  { name: "Trent B.", city: "Miami, FL", rating: 5, text: "Night tour hits different. Trail lights, engine roar, no traffic. Absolute rockstar experience." },
  { name: "Amelia G.", city: "Jacksonville, FL", rating: 5, text: "First time on a Talon, will not be my last. Family-friendly and legit thrilling." },
  { name: "Owen K.", city: "Sanford, FL", rating: 5, text: "Way better than any theme park line. Book Rockstar first, thank me later." },
  { name: "Rosa L.", city: "Winter Park, FL", rating: 5, text: "The 4-seater was clutch for the whole crew. Photos they took were fire." },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Real Trails. Real Machines.",
    body:
      "We don't do plastic rentals or scripted routes. Our garage is stocked with Honda Talon 1000s and Rancher 420s — the same machines that dominate Florida's off-road scene.",
  },
  {
    n: "02",
    title: "The Two-Hour Beach Ride.",
    body:
      "Book the flagship two-hour tour and explore a hidden creek-style beach — soft sand, crystal-clear spring-fed water, a rock cliff, and a rope swing from the trees straight into the water. Ask the guide for pictures — you'll want them.",
  },
  {
    n: "03",
    title: "Built for Families & Friends.",
    body:
      "Ages 10+ drive an ATV. 18+ drive a UTV. Ages 2+ ride shotgun. Everyone leaves muddy, sunburnt, and grinning. That's the whole point.",
  },
  {
    n: "04",
    title: "After Dark? We Ride Anyway.",
    body:
      "Bookings 8 PM or later unlock the Night Tour add-on — just $99 per group. Trail lights on, adrenaline up, Florida moon overhead.",
  },
];
